export default "/images/c0202b8b5ca603b5dad5a222f4d65e17.avif";